import React from 'react'
import { useVesselLanding } from '../context/VesselLandingContext'

type Props = {
  vesselId?: number | null
  label?: React.ReactNode
  vesselName?: React.ReactNode
  className?: string
  title?: string
}

const VesselLandingLink: React.FC<Props> = ({ vesselId, label, vesselName, className, title }) => {
  const content = label ?? vesselName ?? '-'
  const { openVesselLanding } = useVesselLanding()

  if (!vesselId || !Number.isFinite(Number(vesselId))) {
    return <span className={className}>{content}</span>
  }

  return (
    <button
      type='button'
      className={className}
      title={title}
      style={{ background: 'none', border: 0, padding: 0, textAlign: 'inherit' }}
      onClick={(event) => {
        event.preventDefault()
        event.stopPropagation()
        openVesselLanding(Number(vesselId))
      }}
    >
      {content}
    </button>
  )
}

export default VesselLandingLink
